module.exports = __webpack_public_path__ + "img/apple-store.03e97866.png";